module.exports = __webpack_public_path__ + "img/防伪页面.bb7ab774.png";